module.exports = __webpack_public_path__ + "img/torusDashboard3.385d40ab.svg";